import { useMutation } from 'react-query';

import { createProject } from 'shared/api/projects/http';

const useMutateCreateProject = (options = undefined) => useMutation(createProject, options);

export default useMutateCreateProject;
